
(function(){
  'use strict';
  var d=document, w=window, body=d.body;
  body.classList.remove('no-js'); body.classList.add('js');
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  /* ---------- nav ---------- */
  var nav=d.getElementById('nav');
  function onScroll(){ nav.classList.toggle('is-scrolled', w.scrollY>30); }
  w.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  if (!d.querySelector('.hero, .page-hero')) nav.classList.add('on-light');

  var burger=d.getElementById('burger'), menu=d.getElementById('menu');
  if (burger && menu){
    burger.addEventListener('click', function(){
      var open=!menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open); burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open); menu.setAttribute('aria-hidden', !open);
      body.classList.toggle('menu-open', open);
    });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ burger.click(); }); });
    var mg=d.getElementById('menuProducts'), mt=mg && mg.querySelector('.menu-toggle');
    if (mt){ mt.addEventListener('click', function(){ var open=!mg.classList.contains('is-open'); mg.classList.toggle('is-open', open); mt.setAttribute('aria-expanded', open); }); }
  }

  /* ---------- products dropdown (desktop nav) ---------- */
  var dropItem=d.getElementById('productsNav'), dropBtn=d.getElementById('productsBtn'), dropMenu=d.getElementById('productsMenu');
  if (dropItem && dropBtn && dropMenu){
    function setDrop(open){ dropItem.classList.toggle('is-open', open); dropBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    dropBtn.addEventListener('click', function(e){ e.stopPropagation(); setDrop(!dropItem.classList.contains('is-open')); });
    dropBtn.addEventListener('keydown', function(e){ if (e.key==='ArrowDown'){ e.preventDefault(); setDrop(true); var f=dropMenu.querySelector('a'); if(f) f.focus(); } });
    dropMenu.addEventListener('keydown', function(e){
      var links=Array.prototype.slice.call(dropMenu.querySelectorAll('a')), i=links.indexOf(d.activeElement);
      if (e.key==='ArrowDown'){ e.preventDefault(); (links[i+1]||links[0]).focus(); }
      else if (e.key==='ArrowUp'){ e.preventDefault(); (links[i-1]||links[links.length-1]).focus(); }
    });
    d.addEventListener('keydown', function(e){ if (e.key==='Escape' && dropItem.classList.contains('is-open')){ setDrop(false); dropBtn.focus(); } });
    d.addEventListener('click', function(e){ if (!dropItem.contains(e.target)) setDrop(false); });
    dropItem.addEventListener('focusout', function(e){ if (!dropItem.contains(e.relatedTarget)) setDrop(false); });
    dropItem.addEventListener('mouseleave', function(){ setDrop(false); });
    w.addEventListener('scroll', function(){ if (dropItem.classList.contains('is-open')) setDrop(false); }, {passive:true});
  }

  /* ---------- progress bar ---------- */
  var bar=d.getElementById('progressBar');
  function prog(){ var h=d.documentElement; var max=h.scrollHeight-h.clientHeight; bar.style.transform='scaleX('+(max>0? w.scrollY/max : 0)+')'; }
  w.addEventListener('scroll', prog, {passive:true}); w.addEventListener('resize', prog); prog();

  /* ---------- split text ---------- */
  function splitEl(el){
    if (el.dataset.splitDone) return;
    var text=el.textContent; el.textContent='';
    text.split(' ').forEach(function(word, i, arr){
      var ws=d.createElement('span'); ws.className='word';
      word.split('').forEach(function(ch){ var cs=d.createElement('span'); cs.className='char'; cs.textContent=ch; ws.appendChild(cs); });
      el.appendChild(ws); if (i<arr.length-1) el.appendChild(d.createTextNode(' '));
    });
    el.dataset.splitDone='1';
  }
  var heroTitle=d.getElementById('heroTitle');
  if (heroTitle){ heroTitle.querySelectorAll('.line').forEach(splitEl); }
  d.querySelectorAll('[data-split]').forEach(splitEl);

  if (!hasGsap || reduce){
    d.querySelectorAll('.reveal-up').forEach(function(el){ el.style.opacity=1; el.style.transform='none'; });
    d.querySelectorAll('.count').forEach(function(el){ el.textContent=fmt(+el.dataset.to, el.dataset); });
    initInteractive(); return;
  }

  /* ---------- hero intro ---------- */
  if (heroTitle){
    var tl=gsap.timeline({defaults:{ease:'power4.out'}});
    tl.from(heroTitle.querySelectorAll('.char'), {yPercent:110, rotateZ:4, opacity:0, duration:1.1, stagger:0.025}, 0.1)
      .from('.hero-sub', {y:24, opacity:0, duration:.8}, 0.8)
      .from('.hero-cta .btn', {y:20, opacity:0, duration:.7, stagger:.1}, 1.0)
      .to('.hero .reveal-up', {y:0, opacity:1, duration:.8, stagger:.1}, 0.6);
    // gentle parallax on scroll-out (no opacity fade: text stays fully opaque)
    gsap.to('.hero-inner', {yPercent:18, ease:'none', scrollTrigger:{trigger:'#hero', start:'top top', end:'bottom top', scrub:true}});
    gsap.to('.hero-bg', {yPercent:20, ease:'none', scrollTrigger:{trigger:'#hero', start:'top top', end:'bottom top', scrub:true}});
    if (fine){
      // mouse parallax on the hero background (the blobs' own CSS drift keeps running underneath)
      var hb=d.querySelector('.hero .hero-bg');
      if (hb){ gsap.set(hb, {scale:1.06}); var hbx=gsap.quickTo(hb,'x',{duration:1.4,ease:'power3'}), hby=gsap.quickTo(hb,'y',{duration:1.4,ease:'power3'});
        w.addEventListener('mousemove', function(e){ hbx((e.clientX/w.innerWidth-.5)*-28); hby((e.clientY/w.innerHeight-.5)*-18); }, {passive:true}); }
    }
  }
  d.querySelectorAll('.page-hero').forEach(function(ph){
    gsap.to(ph.querySelector('.hero-bg'), {yPercent:30, ease:'none', scrollTrigger:{trigger:ph, start:'top top', end:'bottom top', scrub:true}});
  });

  /* ---------- scramble words ---------- */
  var sc=d.getElementById('scramble');
  if (sc){
    var words=sc.dataset.words.split(','), wi=0, chars='abcdefghijklmnopqrstuvwxyz';
    function fitWidth(){
      var probe=d.createElement('span'); var cs=getComputedStyle(sc);
      probe.style.cssText='position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0;font:'+cs.font+';letter-spacing:'+cs.letterSpacing;
      d.body.appendChild(probe); var max=0;
      words.forEach(function(wd){ probe.textContent=wd; max=Math.max(max, probe.getBoundingClientRect().width); });
      d.body.removeChild(probe); sc.style.width=Math.ceil(max+1)+'px';
    }
    fitWidth(); if (d.fonts && d.fonts.ready) d.fonts.ready.then(fitWidth); w.addEventListener('resize', fitWidth);
    function scrambleTo(word){
      var frame=0, len=word.length, total=18;
      (function step(){
        var out='';
        for (var i=0;i<len;i++){ out += (i < frame*len/total) ? word[i] : (word[i]===' '?' ':chars[Math.floor(Math.random()*chars.length)]); }
        sc.textContent=out; frame++;
        if (frame<=total) requestAnimationFrame(step); else sc.textContent=word;
      })();
    }
    setInterval(function(){ wi=(wi+1)%words.length; scrambleTo(words[wi]); }, 2600);
  }

  /* ---------- split headings reveal on scroll ---------- */
  d.querySelectorAll('[data-split]').forEach(function(el){
    gsap.from(el.querySelectorAll('.char'), {yPercent:110, opacity:0, rotateZ:3, duration:.9, ease:'power4.out', stagger:0.015,
      scrollTrigger:{trigger:el, start:'top 88%', once:true}});
  });
  /* ---------- generic reveals (grouped per parent for stagger) ---------- */
  var groups=new Map();
  d.querySelectorAll('.reveal-up').forEach(function(el){
    if (el.closest('.hero')) return;
    var p=el.parentElement; if(!groups.has(p)) groups.set(p,[]); groups.get(p).push(el);
  });
  groups.forEach(function(els){
    ScrollTrigger.batch(els, {start:'top 90%', once:true, onEnter:function(b){ gsap.to(b, {y:0, opacity:1, duration:.9, ease:'power3.out', stagger:.08, overwrite:true}); }});
  });
  /* ---------- cards: staggered rise + slight rotate ---------- */
  d.querySelectorAll('.grid').forEach(function(grid){
    var cards=grid.querySelectorAll('.card');
    gsap.set(cards, {y:60, opacity:0, rotateX:8, transformOrigin:'50% 100%'});
    ScrollTrigger.batch(cards, {start:'top 92%', once:true, onEnter:function(b){ gsap.to(b, {y:0, opacity:1, rotateX:0, duration:1, ease:'power3.out', stagger:.08, overwrite:true, clearProps:'transform'}); }});
  });
  /* ---------- story image parallax zoom ---------- */
  d.querySelectorAll('.story').forEach(function(s){
    var img=s.querySelector('.story-media img'); if(!img) return;
    if (s.classList.contains('story-dark')){
      gsap.fromTo(img, {scale:1.25, yPercent:-6}, {scale:1, yPercent:6, ease:'none', scrollTrigger:{trigger:s, start:'top bottom', end:'bottom top', scrub:true}});
    } else {
      // product photo: whole product stays inside its padded card (drift only, no zoom)
      gsap.fromTo(img, {yPercent:-3}, {yPercent:3, ease:'none', scrollTrigger:{trigger:s, start:'top bottom', end:'bottom top', scrub:true}});
    }
  });
  d.querySelectorAll('.col-media img, .category-image img').forEach(function(img){
    gsap.fromTo(img, {yPercent:-3}, {yPercent:3, ease:'none', scrollTrigger:{trigger:img.parentElement, start:'top bottom', end:'bottom top', scrub:true}});
  });
  /* ---------- counters ---------- */
  d.querySelectorAll('.count').forEach(function(el){
    var o={v:0}, to=+el.dataset.to;
    ScrollTrigger.create({trigger:el, start:'top 90%', once:true, onEnter:function(){ gsap.to(o, {v:to, duration:1.8, ease:'power3.out', onUpdate:function(){ el.textContent=fmt(Math.round(o.v), el.dataset); }}); }});
  });
  /* ---------- background colour morph per section ---------- */
  d.querySelectorAll('[data-bg]').forEach(function(sec){
    ScrollTrigger.create({trigger:sec, start:'top 80%', end:'bottom 20%',
      onEnter:function(){ gsap.to(body, {backgroundColor:sec.dataset.bg, duration:.8, overwrite:'auto'}); },
      onEnterBack:function(){ gsap.to(body, {backgroundColor:sec.dataset.bg, duration:.8, overwrite:'auto'}); }});
  });
  /* ---------- nav theme ---------- */
  initInteractive();

  function fmt(n, ds){ var s = ds.sep ? n.toLocaleString('en-US') : String(n); return s+(ds.suffix||''); }

  function initInteractive(){
    /* tilt + glow on cards */
    if (fine && !reduce){
      d.querySelectorAll('[data-tilt]').forEach(function(card){
        var r, raf;
        card.addEventListener('pointerenter', function(){ r=card.getBoundingClientRect(); });
        card.addEventListener('pointermove', function(e){
          if(!r) r=card.getBoundingClientRect();
          var px=(e.clientX-r.left)/r.width, py=(e.clientY-r.top)/r.height;
          cancelAnimationFrame(raf);
          raf=requestAnimationFrame(function(){ card.style.transform='perspective(1000px) rotateX('+((.5-py)*10)+'deg) rotateY('+((px-.5)*12)+'deg) translateY(-4px)'; card.style.transition='transform .12s ease-out, border-color .4s, box-shadow .4s'; });
        });
        card.addEventListener('pointerleave', function(){ card.style.transition='transform .7s cubic-bezier(.22,1,.36,1), border-color .4s, box-shadow .4s'; card.style.transform=''; r=null; });
      });
      /* magnetic buttons */
      d.querySelectorAll('.btn-magnetic').forEach(function(b){
        var inner=b.querySelector('span');
        b.addEventListener('pointermove', function(e){
          var r=b.getBoundingClientRect(), x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2;
          b.style.transform='translate('+x*.25+'px,'+y*.35+'px)'; if(inner) inner.style.transform='translate('+x*.12+'px,'+y*.15+'px)';
        });
        b.addEventListener('pointerleave', function(){ b.style.transform=''; if(inner) inner.style.transform=''; });
      });
    }
    /* filters + search */
    var grid=d.getElementById('grid'), chips=d.querySelectorAll('.filters .chip'), search=d.getElementById('search'), countNum=d.getElementById('countNum'), empty=d.getElementById('empty');
    if (grid && chips.length){
      var cur='all', q='';
      function apply(animate){
        var cards=grid.querySelectorAll('.card'), shown=0;
        cards.forEach(function(c){
          var okCat = cur==='all' || (' '+c.dataset.cats+' ').indexOf(' '+cur+' ')>-1;
          var okQ = !q || (c.dataset.name+' '+c.dataset.types.toLowerCase()).indexOf(q)>-1;
          var show=okCat&&okQ; c.classList.toggle('is-hidden', !show); if(show) shown++;
        });
        if (countNum) countNum.textContent=shown; if (empty) empty.hidden = shown>0;
        if (animate && hasGsap && !reduce){ gsap.fromTo(grid.querySelectorAll('.card:not(.is-hidden)'), {y:24, opacity:0, scale:.98}, {y:0, opacity:1, scale:1, duration:.6, ease:'power3.out', stagger:.04, overwrite:true, clearProps:'transform'}); }
        if (hasGsap) ScrollTrigger.refresh();
      }
      chips.forEach(function(ch){ ch.addEventListener('click', function(){ chips.forEach(function(x){x.classList.remove('is-active');}); ch.classList.add('is-active'); cur=ch.dataset.filter; apply(true); }); });
      if (search) search.addEventListener('input', function(){ q=search.value.trim().toLowerCase(); apply(false); });
      var hash=location.hash.replace('#','');
      if (hash && hash!=='lineup'){ chips.forEach(function(ch){ if(ch.dataset.filter===hash){ ch.click(); } }); }
    }
    /* product gallery */
    var slides=d.getElementById('slides');
    if (slides){
      var thumbs=d.querySelectorAll('.thumb'), count=d.getElementById('gcount'), n=slides.children.length, idx=0;
      function go(i, smooth){ idx=(i+n)%n; slides.scrollTo({left:slides.clientWidth*idx, behavior: smooth===false?'auto':'smooth'}); }
      function sync(){ var i=Math.round(slides.scrollLeft/slides.clientWidth); if(i!==idx){ idx=i; } thumbs.forEach(function(t,k){ t.classList.toggle('is-active', k===idx); }); if(count) count.textContent=(idx+1)+' / '+n; }
      slides.addEventListener('scroll', function(){ requestAnimationFrame(sync); }, {passive:true});
      d.getElementById('prev').addEventListener('click', function(){ go(idx-1); });
      d.getElementById('next').addEventListener('click', function(){ go(idx+1); });
      thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.dataset.i); }); });
      d.addEventListener('keydown', function(e){ if(e.key==='ArrowLeft') go(idx-1); if(e.key==='ArrowRight') go(idx+1); });
    }
  }
})();
